import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { ApiResponse } from '../models/api-response';

@Injectable({ providedIn: 'root' })
export class ProfileService {
  private host: string = environment.apiUrl;

  constructor(private http: HttpClient) { }

  private authHeaders() {
    const token = localStorage.getItem('tokenConnectedUserWSU1234567GHTVB');
    return new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': token });
  }



  getUser(username: string) {
    return this.http.get(this.host + "/users/profile/" + username, { headers: this.authHeaders() });
  }

  getUtilisateursInformations(email: string) {
    return this.http.get(this.host + "/users/profile/informations/" + email, { headers: this.authHeaders() });
  }

  addsecretQuestion(id: any, formdata: any) {
    return this.http.post(this.host + "/users/profile/add/question/reponse/" + id, formdata, { headers: this.authHeaders() });
  }



  changeUserinformation(id: any, formdata: any) {
    return this.http.put(this.host + "/users/profile/information/update/" + id, formdata, { headers: this.authHeaders() });
  }



  getUserContactTelephonique() {
    const username = localStorage.getItem('usernameThatUserIsNowConnect2345789');
    return this.http.get(this.host + "/users/profile/phones/number/" + username, { headers: this.authHeaders() });
  }

  ConfirmationTokenSMS(phone: string) {
    return this.http.post(this.host + "/users/profile/confirmation/token/to/phone/" + phone, null, { headers: this.authHeaders() });
  }

  confirmContactNumber(token: string) {
    return this.http.post(this.host + "/users/profile/confirm/contact/number/" + token, null, { headers: this.authHeaders() });
  }

  getUserIdentity() {
    const username = localStorage.getItem('usernameThatUserIsNowConnect2345789');
    return this.http.get(this.host + "/users/profile/mes/pieces/pour/identification/" + username, { headers: this.authHeaders() });
  }






  updateUserPassword(payload: { code: string; password: string; username: string }) {
    return this.http.post<ApiResponse>(
      this.host + "/spay/security/securitypasword/update",
      payload,
      { headers: this.authHeaders() }
    );
  }


  getSecurityStatus(username: string) {
    console.log("Getting security status for user:", username);
    return this.http.get<{ secure: boolean; secretQuestion?: string }>(this.host + `/spay/security/status/${username}`, { headers: this.authHeaders() });

  }

  setupSecurity(payload: {
    secretQuestion: string;
    secretAnswer: string;
    secretPin: string;
    contraintPin: string;
    username: string;
  }) {
    return this.http.post(this.host + '/spay/security/setup', payload, { headers: this.authHeaders() });
  }

  verifySecretAnswer(payload: { answer: string, username: string }) {
    console.log("Verifying secret answer for user:", payload)
    return this.http.post(this.host + '/spay/security/verify-answer', payload, { headers: this.authHeaders() });
  }

  securityPinForgotInit(payload: { usernameOrEmail: string }) {
    return this.http.post(this.host + '/spay/security/securitypin/forgot/init', payload, { headers: this.authHeaders() });
  }

  securityPinForgotConfirm(payload: { usernameOrEmail: string, otp: string, newSecretPin: string }) {
    return this.http.post(this.host + '/spay/security/securitypin/forgot/confirm', payload, { headers: this.authHeaders() });
  }

  updateSecurityCode(payload: { answer: string; oldSecretPin: string; newSecretPin: string; username: string }) {
    return this.http.post(this.host + '/spay/security/update-code', payload, { headers: this.authHeaders() });
  }
  updateLanguage(lang: string) {
    return this.http.post<ApiResponse>(this.host + '/spay/security/update/lang', { lang }, { headers: this.authHeaders() }
    );
  }

  getPincodePourAchat(email: string) {
    return this.http.get(this.host + "/spay/security/" + email + "/mypincode", { headers: this.authHeaders() });
  }

  getPincodeRetrait(email: string) {
    return this.http.get(this.host + "/spay/security/" + email + "/coderetrait", { headers: this.authHeaders() });
  }

  getPinretraitBussness(accountnumber: string) {
    return this.http.get(this.host + "/spay/security/" + accountnumber + "/coderetrait/bussness", { headers: this.authHeaders() });
  }


}
